module.exports = __webpack_public_path__ + "img/tintuc16.0f8f4e13.png";